import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ContextService } from '@maximizer/core/shared/data-access';
import { Observable, map } from 'rxjs';
import { Octopus } from '@maximizer/core/shared/domain';

export interface EmailMessageResponse extends Octopus.Response {
  EmailMessage: Octopus.WriteResponse<EmailMessage>;
}

export interface EmailMessageRequest {
  EmailMessage: Octopus.WriteRequest<EmailMessage>;
}

export interface EmailMessage {
  Key?: string | null;
  From: string;
  To: string[];
  Cc?: string[];
  Bcc?: string[];
  Subject: string;
  Type: number;
  Body: string;
}

@Injectable()
export class EmailService {
  private readonly http = inject(HttpClient);
  private readonly context = inject(ContextService);

  create(request: EmailMessageRequest): Observable<EmailMessageResponse> {
    return this.http.post<EmailMessageResponse>(
      `${this.context.api}${Octopus.Action.CREATE}`,
      request,
    );
  }

  sendSuggestion(
    request: EmailMessageRequest,
  ): Observable<EmailMessage | undefined> {
    return this.create(request).pipe(
      map((result) => {
        if (result.Code === Octopus.ResponseStatusCode.Successful) {
          return result.EmailMessage.Data;
        }
        return undefined;
      }),
    );
  }
}
